import axios from 'axios';
import Cookies from 'js-cookie';
import { addWatchLaterAction } from './WatchLaterSlice';

const fetchWatchLater = (cartoonId) => {
    const token = Cookies.get('auth_token')
  return async (dispatch) => {
    const fetchData = async () => {
      const body = {cartoonId};
      const url = `${process.env.REACT_APP_DEV_URI}/user/watchLater`;
      const response = await axios.post(url, body, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}`},
      });
      return response;
    };
    try {
      const addWatchLater = await fetchData();
      return dispatch(addWatchLaterAction.addWatchLaterHandler({ addWatchLater }));
    } catch (e) {}
  };
};

export default fetchWatchLater;
